import BusControllers from "../../../../pages-v1/BusControllers";

export const Page = BusControllers;
